import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AddUsersField, validateUsers } from './AddUsersField';

// Each list may be empty: the data personas are often not known when a spoke
// is requested, and people can be added to the groups later. Every user that
// is added must be an admin account.
export const AddUsersFieldExtension = FormFieldBlueprint.make({
  name: 'add-users-field',
  params: {
    field: async () =>
      createFormField({
        name: 'AddUsersField',
        component: AddUsersField,
        validation: validateUsers,
      }),
  },
});
